import React, { useState, useContext } from 'react';
import {
	Paper,
	Container,
	Button,
	Stack,
	TextField,
	FormControl,
	InputLabel,
	Select,
	MenuItem
} from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCirclePlus } from '@fortawesome/free-solid-svg-icons';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import moment from 'moment/moment';
import { simpleMessage } from '../../../../helpers/Helpers';
import { addPermisoAsync } from '../../../../api/Nomina';
import { getToken } from '../../../../api/Account';
import { DataContext } from '../../../../context/DataContext';

const AddPermiso = ({ id, setShowModal, reload, setReload }) => {
	const [fecha, setFecha] = useState(new Date());

	const [isJustificado, setIsJustificado] = useState(1);
	const [horasSolicitadas, setHorasSolicitadas] = useState(1);
	const [motivo, setMotivo] = useState('');

	const { setIsLoading, setIsUnautorized } = useContext(DataContext);

	const token = getToken();

	const saveChanges = async () => {
		if (motivo.length === 0) {
			simpleMessage('Ingrese un motivo', 'error');
			return;
		}

		const data = {
			employeeId: parseInt(id),
			motivo,
			fecha: moment(fecha).format('YYYY-MM-DD'),
			isJustificado,
			horasAusencia: horasSolicitadas
		};

		setIsLoading(true);
		const result = await addPermisoAsync(token, data);
		if (!result.statusResponse) {
			setIsLoading(false);
			if (result.error === 'Unauthorized') {
				setIsUnautorized(true);
				return;
			}
			simpleMessage(result.error, 'error');
			return;
		}
		setIsLoading(false);
		simpleMessage('Constancia Agregada...!', 'success');
		setReload(!reload);
		setShowModal(false);
	};

	return (
		<div>
			<Container style={{ width: 550 }}>
				<Paper
					elevation={10}
					style={{
						padding: 20
					}}
				>
					<Stack spacing={2}>
						<FormControl fullWidth style={{ textAlign: 'left', marginTop: 20 }}>
							<InputLabel id="demo-simple-select-standard-label">
								Tipo Permiso
							</InputLabel>
							<Select
								labelId="demo-simple-select-standard-label"
								id="demo-simple-select-standard"
								onChange={(e) => setIsJustificado(e.target.value)}
								value={isJustificado}
								label="Tipo Permiso"
							>
								<MenuItem value={1}>JUSTIFICADO</MenuItem>
								<MenuItem value={2}>INJUSTIFICADO</MenuItem>
							</Select>
						</FormControl>

						<Stack spacing={2} direction="row">
							<DesktopDatePicker
								closeOnSelect
								label="Fecha"
								inputFormat="DD/MM/YYYY"
								value={fecha}
								onChange={(newValue) => setFecha(newValue)}
								renderInput={(params) => <TextField {...params} />}
							/>

							<FormControl style={{ textAlign: 'left', width: 200 }}>
								<InputLabel id="demo-simple-select-standard-label">
									Horas Ausencia
								</InputLabel>
								<Select
									labelId="demo-simple-select-standard-label"
									id="demo-simple-select-standard"
									onChange={(e) => setHorasSolicitadas(e.target.value)}
									value={horasSolicitadas}
									label="Horas Ausencia"
								>
									<MenuItem value={1}>1</MenuItem>
									<MenuItem value={2}>2</MenuItem>
									<MenuItem value={3}>3</MenuItem>
									<MenuItem value={4}>4</MenuItem>
									<MenuItem value={5}>5</MenuItem>
									<MenuItem value={6}>6</MenuItem>
									<MenuItem value={7}>7</MenuItem>
									<MenuItem value={8}>8</MenuItem>
								</Select>
							</FormControl>
						</Stack>

						<TextField
							required
							fullWidth
							onChange={(e) => setMotivo(e.target.value.toLocaleUpperCase())}
							value={motivo}
							label={'Motivo'}
						/>

						<Button
							variant="outlined"
							startIcon={
								<FontAwesomeIcon icon={faCirclePlus} style={{ marginRight: 20 }} />
							}
							fullWidth
							onClick={() => saveChanges()}
							style={{
								borderRadius: 30,
								color: '#4caf50',
								borderColor: '#4caf50',
								padding: 12
							}}
							size="large"
						>
							Agregar Ausencia
						</Button>
					</Stack>
				</Paper>
			</Container>
		</div>
	);
};

export default AddPermiso;
